import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { APP_API_URL } from "../../utils";
import Loader from "../../components/loader";
import FactureComponent from "../../components/facture";
import ComptableHeader from "../../components/comptable-header";
import InvoiceComponent from "../../components/invoice";
import MagasinierLayout from "../../layout/magasinier-layout";

export default function ControllerInvoice() {
  const { ref } = useParams();
  const user = useSelector((state) => state.auth.user);
  const [invoiceData, setInvoiceData] = useState({});
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fonction pour récupérer les données de la commande
  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${APP_API_URL}/commandes/reference/${ref}`, {
        params: {
          user_id: user.id, // Passer l'ID de l'utilisateur comme paramètre
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setInvoiceData(response.data.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des commandes :', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/controller-orders/${invoiceData.id}/validate`, { validated_by_id: user.id }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.status === 200) {
        fetchData();

        setTimeout(() => {
          // Afficher une alerte de succès avec SweetAlert
          Swal.fire({
            icon: 'success',
            title: 'Commande validée !',
            text: response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
        }, 1000);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Des erreurs ont été détectées dans le formulaire.',
          footer: 'Vérifiez les champs et réessayez.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: error.response?.data?.message || 'Rupture de stock sur l\'un des produits',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <MagasinierLayout>
      <div className="mx-auto w-full max-w-6xl bg-white p-4 sm:p-6 lg:p-8">
        <div className="printable w-full">
          <InvoiceComponent isCopy={false} invoiceData={invoiceData} />

          <div className="modal-footer py-4 space-x-4 no-print">
            <button
              type="button"
              onClick={invoiceData.controller_validated === null ? handleSubmit : goBack}
              className="inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 transition-all duration-300"
            >
              {invoiceData.controller_validated === null ? 'Valider' : 'Retour'}
            </button>
          </div>
        </div>
      </div>
    </MagasinierLayout>
  );
}